import { render } from "./CategoryDeleteComponent.vue?vue&type=template&id=36f075aa"
import script from "./CategoryDeleteComponent.vue?vue&type=script&lang=js"
export * from "./CategoryDeleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__